import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Globals } from '.././globals';
import * as CryptoJS from 'crypto-js';


@Injectable()
export class TestSeriesService {
  adv: any;
  constructor(private http: HttpClient, private _global: Globals) { }

  readonly rootUrl = this._global.siteUrl;

  // add test paper data
  addtestpaper(tpObj, tpId) {

    const body = {
      data: tpObj,
      id: tpId,
    }

    return this.http.post(this.rootUrl + 'test-series/addtestpaper', body);
  }

  // get test paper data 
  gettestpaperlist(Obj) {
    var reqHeader = new HttpHeaders({ 'No-Auth': 'True' });
    return this.http.post(this.rootUrl + 'test-series/gettestpaperlist', Obj, { headers: reqHeader });
  }

  // get test paper data 
  gettestpaperdata(Obj) {
    var reqHeader = new HttpHeaders({ 'No-Auth': 'True' });
    return this.http.post(this.rootUrl + 'test-series/gettestpaperdata', Obj, { headers: reqHeader });
  }

  // get test paper data 
  getmainstsPaperWiselist(Obj) {
    var reqHeader = new HttpHeaders({ 'No-Auth': 'True' });
    return this.http.post(this.rootUrl + 'test-series/getmainstsPaperWiselist', Obj, { headers: reqHeader });
  }

  //del test paper data
  deltestpaper(tpId) {
    var reqHeader = new HttpHeaders({ 'No-Auth': 'True' });
    return this.http.post(this.rootUrl + 'test-series/deletetestpaper', tpId, { headers: reqHeader });
  }

  //del advertisement
  streamlist(streamId) {
    var reqHeader = new HttpHeaders({ 'No-Auth': 'True' });
    //return this.http.post(this.rootUrl + 'session/getstreamtypelist', sId,{ headers: reqHeader});
    return this.http.get(this.rootUrl + 'session/getstreamtypelist?cid=' + btoa(streamId), { headers: reqHeader });
  }



  // add mains test series data
  addmainstestseries(tpObj, tpId) {

    const body = {
      data: tpObj,
      id: tpId,
    }

    return this.http.post(this.rootUrl + 'test-series/addmainstestseries', body);
  }

  // get mains test series data 
  getmainstslist(Obj) {
    var reqHeader = new HttpHeaders({ 'No-Auth': 'True' });
    return this.http.post(this.rootUrl + 'test-series/getmainstslist', Obj, { headers: reqHeader });
  }

  // get mains test series filtered data  
  getmainstsFilterlist(Obj) {
    var reqHeader = new HttpHeaders({ 'No-Auth': 'True' });
    return this.http.post(this.rootUrl + 'test-series/getmainstsFilterlist', Obj, { headers: reqHeader });
  }

  //del mains test series
  delmainstestseries(tpId) {
    var reqHeader = new HttpHeaders({ 'No-Auth': 'True' });
    return this.http.post(this.rootUrl + 'test-series/deletemainstestseries', tpId, { headers: reqHeader });
  }


  // add mains test series data
  addFiles(tpObj) {

    const body = {
      data: tpObj
    }

    return this.http.post(this.rootUrl + 'test-series/addFiles', body);
  }

  //del mains test series
  delFile(obj) {
    var reqHeader = new HttpHeaders({ 'No-Auth': 'True' });
    return this.http.post(this.rootUrl + 'test-series/deleteFiles', obj, { headers: reqHeader });
  }

  getBatchByCenter(centerId) {
    return this.http.get(this.rootUrl + 'session/getbatchByCenter?cid=' + (centerId));
  }


  // add mains test series data
  addStructuretp(Obj, tpid) {

    const body = {
      tpId: tpid,
      data: Obj
    }

    return this.http.post(this.rootUrl + 'test-series/addPaperStructure', body);
  }

  importofflinestudentpurchitem(student, user, testseriesId) {
    const body = {
      students: student,
      createdBy: user.id,
      testseriesId: testseriesId
    }
    return this.http.post(this.rootUrl + 'test-series/importofflinestudentpurchitem', body);
  }

  getstudentpurchaselist(Obj) {
    var reqHeader = new HttpHeaders({ 'No-Auth': 'True' });
    return this.http.post(this.rootUrl + 'test-series/getstudentpurchaselist', Obj, { headers: reqHeader });
  }

  uploadanswersheet(Obj) {
    console.log('dfdf');
    var reqHeader = new HttpHeaders({ 'No-Auth': 'True' });
    return this.http.post(this.rootUrl + 'test-series/uploadanswersheet', Obj);
  }

  getteststreams(Obj) {
    var reqHeader = new HttpHeaders({ 'No-Auth': 'True' });
    return this.http.get(this.rootUrl + 'test-series/getteststreams', { headers: reqHeader });
  }

  getstudentsubmissionlist(Obj) {
    var reqHeader = new HttpHeaders({ 'No-Auth': 'False' });
    return this.http.post(this.rootUrl + 'test-series/getstudentsubmissionlist', Obj, { headers: reqHeader });
  }

  assignfacultytosubmissionlist(facultyId, Id) {
    const body = {
      id: Id,
      facultyId: facultyId
    }
    return this.http.post(this.rootUrl + 'test-series/assigntofaculty', body);
  }

  getmainscompanylist(Obj) {
    var reqHeader = new HttpHeaders({ 'No-Auth': 'False' });
    return this.http.post(this.rootUrl + 'test-series/getmainscompanylist', Obj, { headers: reqHeader });
  }
  getUserTimeline(Obj) {
    return this.http.post(this.rootUrl + 'test-series/getusertimeline', Obj);

  }

  getEvaluateAnswerSheet(Obj) {
    return this.http.post(this.rootUrl + 'test-series/getevaluatesheet', Obj);
  }
  addEvalution(Obj) {
    return this.http.post(this.rootUrl + 'test-series/addevalution', Obj);
  }

  getassignpaymetList(id) {
    const body = {
      id: id
    }
    var reqHeader = new HttpHeaders({ 'No-Auth': 'True' });
    return this.http.post(this.rootUrl + 'test-series/getassignpaymetList', body, { headers: reqHeader });
  }

  getinvoicelist(Obj) {
    var reqHeader = new HttpHeaders({ 'No-Auth': 'True' });
    return this.http.post(this.rootUrl + 'test-series/getinvoicelist', Obj, { headers: reqHeader });
  }

  generateinvoice(Obj) {
    var reqHeader = new HttpHeaders({ 'No-Auth': 'True' });
    return this.http.post(this.rootUrl + 'test-series/generateinvoice', Obj, { headers: reqHeader });
  }

  getinvoicecount(Obj) {

    var reqHeader = new HttpHeaders({ 'No-Auth': 'True' });
    return this.http.post(this.rootUrl + 'test-series/getinvoicecount', Obj, { headers: reqHeader });

  }

  answercountpaperwise(Obj) {
    var reqHeader = new HttpHeaders({ 'No-Auth': 'True' });
    return this.http.post(this.rootUrl + 'test-series/answercountpaperwise', Obj, { headers: reqHeader });
  }

  getNewInvoiceNo(s, width) {
    var starting = '0';
    return (s.length >= width) ? s : (new Array(width).join(starting) + s).slice(-width);
  }

  getStudentUploadList(Obj) {
    var reqHeader = new HttpHeaders({ 'No-Auth': 'True' });
    return this.http.post(this.rootUrl + 'test-series/getstudentuploadlist', Obj, { headers: reqHeader });
  }

  delfacultyUploadedDoc(obj) {
    return this.http.post(this.rootUrl + 'test-series/delfacultyUploadedDoc', obj);
  }

  gettestpaperdropdownlist(obj) {
    return this.http.post(this.rootUrl + 'test-series/gettestpaperdropdownlist', obj);
  }

  getstudentreportlist(obj) {
    return this.http.post(this.rootUrl + 'test-series/getstudentreportlist', obj);
  }

  addstudentbillinfo(Obj) {
    return this.http.post(this.rootUrl + 'test-series/addstudentbillinfo', Obj);
  }
  getpaymnetstatus(Obj) {
    return this.http.post(this.rootUrl + 'test-series/getpaymnetstatus', Obj);
  }

  requestforinvoice(id, pakagename) {
    const body = {
      userid: id,
      pakagename: pakagename
    }
    var reqHeader = new HttpHeaders({ 'No-Auth': 'True' });
    return this.http.post(this.rootUrl + 'test-series/requestforinvoice', body, { headers: reqHeader });
  }

  deletepurchasehistory(Obj) {
    var reqHeader = new HttpHeaders({ 'No-Auth': 'False' });
    return this.http.post(this.rootUrl + 'test-series/deletepurchasehistory', Obj, { headers: reqHeader });

  }
  gettestPaper(Obj) {
    return this.http.post(this.rootUrl + 'test-series/gettestPaper', Obj);
  }

  checkuserpackage(Obj) {
    return this.http.post(this.rootUrl + 'test-series/checkuserpackage', Obj);
  }

  getreportmainstslist(Obj) {
    return this.http.post(this.rootUrl + 'test-series/getreportmainstslist', Obj);
  }

  generateinvoicepdf(Obj) {
    return this.http.post(this.rootUrl + 'test-series/generateinvoicepdf', Obj);
  }

  getorder(Obj) {
    return this.http.post(this.rootUrl + 'test-series/getorder', Obj);
  }

  updatePackageOfflineUser(Obj) {
    return this.http.post(this.rootUrl + 'test-series/updatePackageOffline', Obj);
  }

  getStudentDetailedReport(Obj) {
    return this.http.post(this.rootUrl + 'test-series/getStudentDetailedReport', Obj);
  }
  getTopperReport(Obj) {
    return this.http.post(this.rootUrl + 'test-series/getTopperReport', Obj);
  }

  getAllReportList(Obj) {
    return this.http.post(this.rootUrl + 'test-series/getAllReportList', Obj);

  }

  GetOrderStudentList(Obj) {
    return this.http.post(this.rootUrl + 'test-series/GetOrderStudentList', Obj);
  }

  exportstudentpurchaselist(Obj) {
    var fromdate = Obj.Fromdate.year + '-' + Obj.Fromdate.month + '-' + Obj.Fromdate.day;
    var todate = Obj.Todate.year + '-' + Obj.Todate.month + '-' + Obj.Todate.day;

    const body = {
      fromdate: fromdate,
      todate: todate,
      streamId: Obj.streamId,
      testseriesId: Obj.testseriesId
    }

    var reqHeader = new HttpHeaders({ 'No-Auth': 'false' });
    return this.http.post(this.rootUrl + 'test-series/exportstudentpurchaselist', body, { headers: reqHeader });
  }

  exportstudenevaluationlist(Obj) {

    var reqHeader = new HttpHeaders({ 'No-Auth': 'false' });
    return this.http.post(this.rootUrl + 'test-series/exportstudenevaluationlist', Obj, { headers: reqHeader });
  }

  importofflineToppers(offlinetopper, userId, paperId, importType) {
    const body = {
      offlinetopper: offlinetopper,
      createdBy: userId,
      paperId: paperId,
      importType: importType
    }
    return this.http.post(this.rootUrl + 'test-series/importofflineToppers', body);
  }

  changetestSeriesStatus(status, id) {
    const body = {
      id: id,
      testSeriesStatus: status

    }
    return this.http.post(this.rootUrl + 'test-series/changetestseriesstatus', body);

  }

  getmonthlyandyearlypaymentgraf(obj) {
    return this.http.post(this.rootUrl + 'test-series/getmonthlyandyearlypaymentgraf', obj);
  }
  getFacultyReportmainstslist(Obj) {
    return this.http.post(this.rootUrl + 'test-series/getFacultyReportmainstslist', Obj);
  }
  getFacultyReportTestpererlist(Obj) {
    return this.http.post(this.rootUrl + 'test-series/getFacultyReportTestpererlist', Obj);
  }
  addfeedback(body){
    return this.http.post(this.rootUrl + 'test-series/addfeedback', body);
  }
  getfeedback(body){
    return this.http.post(this.rootUrl + 'test-series/getfeedback', body);
  }
  exportFeedback(body){
    return this.http.post(this.rootUrl + 'test-series/exportfeedback', body);
  }
  addTopperCopy(body){
    return this.http.post(this.rootUrl + 'test-series/addTopperCopy', body);
  }

}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/service/test-series.service.ts